import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const Tax = ({ label, amount, loading, currency = "USD" }) => {
  return (
    <div className="flex items-center justify-between text-gray-600">
      <span>{label}</span>
      <div className="h-5">
        {loading ? (
          <i className="fa-solid fa-spinner-third fa-spin h-full text-gray-600" />
        ) : (
          <span>{formatCurrencyFromMinorUnits({ amount, currency })}</span>
        )}
      </div>
    </div>
  )
}

Tax.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  currency: PropTypes.string,
}

export default Tax
